import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FaUser, FaUpload, FaUserTie, FaUsers, FaCog } from "react-icons/fa";

const Sidebar = () => {
  const location = useLocation();

  return (
    <div
      style={{
        borderRight: "1px solid #E8E8E8",
        width: "250px",
        height: "100vh",
        padding: "20px 0px",
      }}
    >
      <h2 style={{ padding: "20px", marginLeft: "50px" }}>CLNS</h2>
      {/* <ul style={{ listStyle: "none", padding: "0" }}>
        <li>
          <Link
            to="/"
            style={{
              display: "flex",
              alignItems: "center",
              padding: "10px 20px",
              textDecoration: "none",
              color: location.pathname === "/" ? "white" : "black",
              backgroundColor:
                location.pathname === "/" ? "#007bff" : "transparent",
              borderRadius: "8px",
              fontWeight: location.pathname === "/" ? "bold" : "normal",
              margin: "10px 20px",
            }}
          >
            <FaUsers style={{ marginRight: "10px" }} /> Dashboard
          </Link>
        </li>
      </ul> */}
      <br></br>
      <p style={{ marginTop: "-20px", marginLeft: "20px" }}>Users</p>
      <ul style={{ listStyle: "none", padding: "0" }}>
        <li>
          <Link
            to="/lawyers"
            style={{
              display: "flex",
              alignItems: "center",
              padding: "10px 20px",
              textDecoration: "none",
              color: location.pathname === "/lawyers" ? "white" : "black",
              backgroundColor:
                location.pathname === "/lawyers" ? "#007bff" : "transparent",
              borderRadius: "8px",
              fontWeight: location.pathname === "/lawyers" ? "bold" : "normal",
              margin: "10px 20px",
            }}
          >
            <FaUsers style={{ marginRight: "10px" }} /> Lawyer
          </Link>
        </li>
        <li>
          <Link
            to="/students"
            style={{
              display: "flex",
              alignItems: "center",
              padding: "10px 20px",
              textDecoration: "none",
              color: location.pathname === "/students" ? "white" : "black",
              backgroundColor:
                location.pathname === "/students" ? "#007bff" : "transparent",
              borderRadius: "8px",
              fontWeight: location.pathname === "/students" ? "bold" : "normal",
              margin: "10px 20px",
            }}
          >
            <FaUsers style={{ marginRight: "10px" }} /> Students
          </Link>
        </li>
        <li>
          <Link
            to="/clients"
            style={{
              display: "flex",
              alignItems: "center",
              padding: "10px 20px",
              textDecoration: "none",
              color: location.pathname === "/clients" ? "white" : "black",
              backgroundColor:
                location.pathname === "/clients" ? "#007bff" : "transparent",
              borderRadius: "8px",
              fontWeight: location.pathname === "/clients" ? "bold" : "normal",
              margin: "10px 20px",
            }}
          >
            <FaUsers style={{ marginRight: "10px" }} /> Clients
          </Link>
        </li>
        <li>
          <Link
            to="/sidebarOffc"
            style={{
              display: "flex",
              alignItems: "center",
              padding: "10px 20px",
              textDecoration: "none",
              color: location.pathname === "/sidebarOffc" ? "white" : "black",
              backgroundColor:
                location.pathname === "/sidebarOffc" ? "#007bff" : "transparent",
              borderRadius: "8px",
              fontWeight: location.pathname === "/sidebarOffc" ? "bold" : "normal",
              margin: "10px 20px",
            }}
          >
            <FaUpload style={{ marginRight: "10px" }} /> Officials
          </Link>
        </li>
      </ul>
      <br></br>
      <p style={{ marginTop: "-20px", marginLeft: "20px" }}>Users</p>
      <ul style={{ listStyle: "none", padding: "0" }}>
        <li>
          <Link
            to="/banner"
            style={{
              display: "flex",
              alignItems: "center",
              padding: "10px 20px",
              textDecoration: "none",
              color: location.pathname === "/banner" ? "white" : "black",
              backgroundColor:
                location.pathname === "/banner" ? "#007bff" : "transparent",
              borderRadius: "8px",
              fontWeight: location.pathname === "/banner" ? "bold" : "normal",
              margin: "10px 20px",
            }}
          >
            <FaUsers style={{ marginRight: "10px" }} /> Banners
          </Link>
        </li>
      </ul>
      <br></br>
      <ul style={{ listStyle: "none", padding: "0" }}>
        <li>
          <Link
            to="/settings"
            style={{
              display: "flex",
              alignItems: "center",
              padding: "10px 20px",
              textDecoration: "none",
              color: location.pathname === "/" ? "white" : "black",
              backgroundColor:
                location.pathname === "/" ? "#007bff" : "transparent",
              borderRadius: "8px",
              fontWeight: location.pathname === "/" ? "bold" : "normal",
              margin: "10px 20px",
            }}
          >
            <FaUsers style={{ marginRight: "10px" }} /> Settings
          </Link>
        </li>
        <li>
          <Link
            to="/"
            style={{
              display: "flex",
              alignItems: "center",
              padding: "10px 20px",
              textDecoration: "none",
              color: location.pathname === "/" ? "white" : "black",
              backgroundColor:
                location.pathname === "/" ? "#007bff" : "transparent",
              borderRadius: "8px",
              fontWeight: location.pathname === "/" ? "bold" : "normal",
              margin: "10px 20px",
            }}
          >
            <FaUsers style={{ marginRight: "10px" }} /> Logout
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
